// LIBRERIE/IMPORTS
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";

//IMG
import imgHouse from "../../../public/assets/images/inHome/villaHero.jpg";

const BannerVendi: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section id="bannerValuta" className="space-ptb">
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-12 col-lg-6 mb-4 mb-lg-0">
            <h2 className="mb-4 mb-xl-5" dangerouslySetInnerHTML={{ __html: t('homePage.sellBanner.title') as string }} />
            <div>
              <p className="mb-4" dangerouslySetInnerHTML={{ __html: t('homePage.sellBanner.para1') as string }} />
              <div className="mb-4">
                <FontAwesomeIcon icon={faStar} className="mr-2"/>
                <FontAwesomeIcon icon={faStar} className="mr-2"/>
                <FontAwesomeIcon icon={faStar} className="mr-2"/>
                <FontAwesomeIcon icon={faStar} className="mr-2"/>
                <FontAwesomeIcon icon={faStar} />
              </div>
              <Link className="btn btn-primary" to="/valutazione">
                <span>{t('homePage.sellBanner.btnText')}</span>
              </Link>
            </div>
          </div>
          <div className="col-12 col-lg-6">
            <div className="img-wrapper">
              <img src={imgHouse} className="img-fluid" alt={`${t('homePage.sellBanner.imgAlt1')}`} />
              <div>
                <p className="p-3 m-0" dangerouslySetInnerHTML={{ __html: t('homePage.sellBanner.para2') as string }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BannerVendi;